module.exports = __webpack_public_path__ + "static/media/blueTick.35328a69.svg";